import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AccountingReportService from './AccountingReportService';

const YearStartUnshippedBeamReport = () => {
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState('');

  const handleExport = async () => {
    setExporting(true);
    setError('');
    try {
      await AccountingReportService.exportYearStartUnshippedBeamPaymentsExcel();
    } catch (e) {
      setError(e?.response?.data?.message || e.message || 'Failed to export Excel');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
            Accounting: เงินค้างส่ง ณ 1 ม.ค. 2026
          </Typography>
          <Typography variant="body2" color="text.secondary">
            รายงานนี้ Export อย่างเดียว (ไม่มีแสดงตารางบนหน้า)
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="success"
            startIcon={<FileDownloadIcon />}
            onClick={handleExport}
            disabled={exporting}
          >
            {exporting ? 'กำลัง Export...' : 'Export Excel'}
          </Button>
        </Box>
      </Box>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
    </Box>
  );
};

export default YearStartUnshippedBeamReport;

